import { render, staticRenderFns } from "./presentationParticulier.vue?vue&type=template&id=4ebd0d89&scoped=true"
import script from "./presentationParticulier.vue?vue&type=script&lang=js"
export * from "./presentationParticulier.vue?vue&type=script&lang=js"
import style0 from "./presentationParticulier.vue?vue&type=style&index=0&id=4ebd0d89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebd0d89",
  null
  
)

export default component.exports